import { Calendar } from "primereact/calendar";
import React from "react";
import { FormSectionElements, FormSubSections } from "src/entities/formTemplateDataType";
import XMLParser from "../../utilities/XMLParser";
import classNames from 'classnames';
import { LiveValidationErrMsg } from "../live-validation-errMsg/LiveValidationErrMsg";
import FormValidationUtils from "../../utilities/FormValidationUtils";
import { getRootComponent, triggerSummaryListFilter, isSummaryLinked, updateFilterSelectionCode } from "../../utilities/ElementUtils";
import Utils from "../../utilities/Utils";

interface Props {
    field: FormSectionElements;
    editable: boolean;
    title;
    labelControlArray;
    requiredField;
    callbackElement;
    isEng: boolean;
}

interface State {

}
export class DateComponent extends React.Component<Props, State> {


    constructor(props: Props) {
        super(props);

        let field = this.props.field;
        field.Touched=false;
        FormValidationUtils.runJavascript(field);
    }

    componentDidMount() {
        const field = this.props.field;
        const fieldAny = field as any;
        
        if (fieldAny?.filterColumnSelectorId && isSummaryLinked(field)) {
            const root = getRootComponent(field);
            const columnSelector = this.findColumnSelectorElement(fieldAny.filterColumnSelectorId, root);
            if (columnSelector) {
                fieldAny._lastSelectedColumn = columnSelector.Value ?? columnSelector.SelectionCode;
            }
        }
    }

    componentDidUpdate(prevProps: Props) {
        const field = this.props.field;
        const fieldAny = field as any;
        
        if (fieldAny?.filterColumnSelectorId && isSummaryLinked(field)) {
            const root = getRootComponent(field);
            const columnSelector = this.findColumnSelectorElement(fieldAny.filterColumnSelectorId, root);
            if (columnSelector) {
                const currentColumn = columnSelector.Value ?? columnSelector.SelectionCode;
                const lastColumn = fieldAny._lastSelectedColumn;
                
                if (lastColumn && currentColumn !== lastColumn && field.Value) {
                    this.clearDateValue();
                }
                fieldAny._lastSelectedColumn = currentColumn;
            }
        }
    }

    findColumnSelectorElement = (selectorId: string, root: any): any => {
        const sections = root?.ListOfFormSections ?? [];
        const findInElements = (elements: any[]): any => {
            for (const element of elements ?? []) {
                if (element.Id === selectorId || element.LoadBindName === selectorId) {
                    return element;
                }
                if (element.subSectionList?.length) {
                    for (const sub of element.subSectionList) {
                        const found = findInElements(sub?.ListOfFormSectionElements);
                        if (found) return found;
                    }
                }
            }
            return null;
        };
        for (const section of sections) {
            for (const subSection of section.ListOfFormSubSections ?? []) {
                const found = findInElements(subSection.ListOfFormSectionElements);
                if (found) return found;
            }
        }
        return null;
    }

    clearDateValue = () => {
        const field = this.props.field;
        field.Value = '';
        field.Touched = false;
        
        FormValidationUtils.validateDate(field);
        FormValidationUtils.runJavascript(field);

        this.props.callbackElement(getRootComponent(field));
        
        if (isSummaryLinked(field)) {
            updateFilterSelectionCode(field, null);
            triggerSummaryListFilter(field);
        }
    }

  onDateChangeOnDialog = (e) => {
    let field = this.props.field;
    if (field.ReadOnly) {
        e?.preventDefault?.();
        return;
    }
    let val = e.target.value;
        field.Touched = true;
        if (!val) {
            this.clearDateValue();
        } else {
            field.Value = new Date(val);
            FormValidationUtils.validateDate(field)
            FormValidationUtils.runJavascript(field);
            field.Value = this.convertToDateString(val);
            
            this.props.callbackElement(getRootComponent(this.props.field));

            if (isSummaryLinked(field)) {
                updateFilterSelectionCode(field, field.Value);
                triggerSummaryListFilter(field);
            }
        }

        let subSection: FormSubSections = this.props.field.parent as FormSubSections;
        let listScriptTriggering = subSection.ListOfFormSectionElements.filter(ele => ele.ScriptTriggerField == this.props.field.LoadBindName);
        if (listScriptTriggering.length > 0) {
            listScriptTriggering.forEach(ele => {
                if (ele.Script) {
                    eval(ele.Script);
                    this.props.callbackElement(getRootComponent(this.props.field));
                }
            })
        }
    }

    convertToDateString = (val) => {
        const date = new Date(val);

       // Extract the month, day, and year
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based, so add 1
        const day = date.getDate().toString().padStart(2, '0');
        const year = date.getFullYear();

        // Format the date as MM/DD/YYYY
        const formattedDateString = `${month}/${day}/${year}`;
        return formattedDateString
    }

    render() {
        let field = this.props.field;
        const fieldAny = field as any;
        
        if (field.Visible === false) {
            if (isSummaryLinked(field) && !fieldAny._invisibleCleared) {
                fieldAny._invisibleCleared = true;
                this.clearDateValue();
            }
            return null;
        }
        
        if (fieldAny._invisibleCleared) {
            fieldAny._invisibleCleared = false;
        }

        let validateCpmpareField;
        let dateValid: boolean = true;

        let displayfield: boolean = true;
        let editable = this.props.editable;
        let labelControlArray = this.props.labelControlArray;
        let requiredField = this.props.requiredField;
        let controlArray = [];
        let title = this.props.title;
        let isDateISOFormat = this.props.field.DateISOFormat;

        const programContainer = getRootComponent(field);

        if (this.props.field.FilterField != null) {
            let filterValue;
            let baseName;
            let bindName;
            let parts = this.props.field.FilterField.split('.');
            if (parts.length == 3) {
                baseName = parts[0] + '.' + parts[1];
                bindName = parts[2];
            }
            if (parts.length == 2) {
                baseName = parts[0];
                bindName = parts[1];
            }
            if (parts.length == 1) {
                baseName = '';
                bindName = parts[0];
            }

            let foundFilterFields = XMLParser.extractFormSectionElement(baseName, bindName);

            let foundFilterField;

            if (foundFilterFields && foundFilterFields.length > 0) {
                foundFilterField = foundFilterFields[0];
            }

            if (foundFilterField != null) {
                filterValue = foundFilterField.Value;

                if (filterValue == null || filterValue != null && this.props.field.FilterValue.indexOf(filterValue) == -1 && filterValue.indexOf(this.props.field.FilterValue) == -1) {
                    displayfield = false;
                }
            }
        }


        if (field.ValidateCompareMethod != null) {
            let subSection = this.props.field.parent as FormSubSections;
            let foundValidateCpmpareFieldList = subSection.ListOfFormSectionElements.filter(p => p.LoadBindName == field.ValidateCompareField);
            if (foundValidateCpmpareFieldList.length > 0) {
                validateCpmpareField = foundValidateCpmpareFieldList[0];
                if (field.ValidateCompareMethod == "<")
                    dateValid = field.Value <= validateCpmpareField.Value;
                else if (field.ValidateCompareMethod == ">") {
                    dateValid = field.Value >= validateCpmpareField.Value;
                } else {
                    dateValid = field.Value == validateCpmpareField.Value;
                }
            }
        }

        const mb = Utils.getSpacingValue(field.MarginBottom);
        const mt = Utils.getSpacingValue(field.MarginTop);
        const dateContainerClass = fieldAny.DateContainerClass || "ontario-date";

        if (displayfield) {
            if (editable) {
                field.ReadOnly = field.parent?.parent?.SectionReadonly === true;
                controlArray.push(
                    <div key={'div_' + field.Datatype + '_' + field.Id} id={'div_' + field.Datatype + '_' + field.Id}
                    className={dateContainerClass} style={{ marginBottom: mb, marginTop: mt }}>

                        {labelControlArray}

                        <LiveValidationErrMsg
                            field={this.props.field}
                            isEng={this.props.isEng}
                            key={"LiveValidationErrMsg_" + field.LoadBindName} />
                        {/* @ts-ignore */}
                        <Calendar showIcon
                            showButtonBar
                            value={(this.props.field.Value == '' || this.props.field.Value == null ? null : new Date(this.props.field.Value))}
                            readOnlyInput={field.ReadOnly}
                            id={field.LoadBindName} 
                            key={'fdIpt_' + field.Id} 
                            ariaLabelledBy={'fd_date_' + field.Id}
                            aria-readonly={field.ReadOnly}
                            monthNavigator
                            yearNavigator
                            yearRange='1900:2100'
                            onChange={this.onDateChangeOnDialog} required={requiredField}
                            inputClassName={field.Valid ? 'ontario-input' : 'ontario-input ontario-input__error'}
                            dateFormat={isDateISOFormat ? 'yy-mm-dd' : 'mm/dd/yy'}
                            panelClassName={fieldAny.DatePanelClass || undefined}/>

                        {/* outside limit error message */} 


                        <span style={{ display: dateValid ? 'none' : 'block', color: 'red' }}>{field.ENUTitle + " must be " + field.ValidateCompareMethod + " " + validateCpmpareField?.ENUTitle}</span>
                    </div>);
            } else {
                    controlArray.push(
                        <div  key={'div_' + field.Datatype + '_' + field.Id} className={programContainer.isHorizontalLayout ? "pdf-row-column" : "pdf-two-column"}
                         style={{ marginBottom: mb, marginTop: mt }}>
                            <div  key={'div2_' + field.Datatype + '_' + field.Id}>{title}</div>
                            <div  key={'div3_' + field.Datatype + '_' + field.Id} className={classNames({ 'invalid-field--highlighted': (this.props.field.Value == '' || this.props.field.Value == null) && requiredField })} >{field.Value ? (new Date(field.Value)).toLocaleDateString() : null}</div>
                        </div>
                    );
            }
        }

        return controlArray;

    }

}
